var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74862 0.442955C9.44934 -0.147652 10.5805 -0.147652 11.2612 0.442955L12.8428 1.79434C13.1431 2.0446 13.7137 2.25482 14.1141 2.25482H15.8159C16.877 2.25482 17.7479 3.12571 17.7479 4.1868V5.88855C17.7479 6.28896 17.9581 6.84954 18.2083 7.14985L19.5597 8.73147C20.1503 9.43219 20.1503 10.5634 19.5597 11.2441L18.2083 12.8257C17.9581 13.126 17.7479 13.6866 17.7479 14.087V15.7887C17.7479 16.8498 16.877 17.7207 15.8159 17.7207H14.1141C13.7137 17.7207 13.1531 17.9309 12.8528 18.1812L11.2712 19.5326C10.5705 20.1232 9.43933 20.1232 8.75863 19.5326L7.17701 18.1812C6.8767 17.9309 6.30611 17.7207 5.91571 17.7207H4.16391C3.10282 17.7207 2.23193 16.8498 2.23193 15.7887V14.077C2.23193 13.6866 2.03172 13.116 1.78146 12.8257L0.430076 11.234C-0.15052 10.5433 -0.15052 9.42218 0.430076 8.73147L1.78146 7.13984C2.03172 6.83953 2.23193 6.27895 2.23193 5.88855V4.19681C2.23193 3.13572 3.10282 2.26483 4.16391 2.26483H5.89569C6.2961 2.26483 6.85668 2.05461 7.15699 1.80435L8.74862 0.442955Z",
    fill: "#E4D9EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 6.13086V10.9658",
    stroke: "#550080",
    strokeWidth: 1.50154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99512 14.0078H10.0041",
    stroke: "#550080",
    strokeWidth: 2.00206,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.6d334862064ac8308ef6dbea0f435908.svg";
export { ForwardRef as ReactComponent };